import { render } from "./footerMobile.vue?vue&type=template&id=f8887d36"
const script = {}

import "../assets/css/template.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__